<div class="herramientas-container">
    <h1>Herramientas</h1>
    <p class="breadcrumb">home/ descúbrete / herramientas</p>

    <div class="tabs-container">
        <div class="tab" [class.active]="activeTab === 'visionboard'" (click)="setActiveTab('visionboard')">
            Visionboard
        </div>
        <div class="tab" [class.active]="activeTab === 'ikigai'" (click)="setActiveTab('ikigai')">
            Ikigai
        </div>
        <div class="tab disabled-tab" [class.active]="activeTab === 'financiera'">
            Financiera
        </div>
    </div>

    <div class="content-container" *ngIf="activeTab === 'visionboard'">
        <!-- Editor de Visionboard -->
        <app-visionboard-editor 
            *ngIf="currentEditorVisionboardId !== null" 
            [visionboardToEditId]="currentEditorVisionboardId"
            (visionboardSaved)="onVisionboardSaved()">
        </app-visionboard-editor>
        
        <!-- Sección de lista/información de Visionboard -->
        <div class="visionboard-section" *ngIf="currentEditorVisionboardId === null">
            <!-- Si no hay Visionboards, mostrar la sección de crear nuevo -->
            <div *ngIf="userVisionboards.length === 0">
                <div class="visionboard-header">
                    <h2>Mis Visionboards</h2>
                    <button class="editar-btn" (click)="navigateToEditor()">Crear Visionboard</button>
                </div>
                <div class="empty-message">
                    <p>Aún no has creado ningún Visionboard.</p>
                </div>
            </div>

            <!-- Loader mientras se cargan los visionboards -->
            <div *ngIf="isLoadingVisionboards" class="loading-message">Cargando tus visionboards...</div>
            
            <!-- Mostrar los visionboards existentes (limitado a uno) -->
            <div *ngIf="!isLoadingVisionboards && userVisionboards.length > 0" class="visionboard-display">
                <div class="visionboard-header">
                    <h2>Visionboard</h2>
                    <button class="editar-btn" (click)="navigateToEditor(userVisionboards[0].id)">Editar</button>
                </div>
                
                <div class="visionboard-layout">
                    <div class="visionboard-description">
                        <p>Una vez creado tu Vision Board, lo revisaremos periódicamente para ajustar tus objetivos y verificar tu progreso. Reflexiona sobre lo que ha funcionado, lo que no, y ajusta tus metas según sea necesario. A veces, sentimos que tenemos que hacerlo todo solos, pero no es así. Tienes a la comunidad de Phoenix que te ayudará en este camino.</p>
                    </div>
                    
                    <div class="visionboard-wrapper">
                        <div class="visionboard-preview">
                            <h3>{{ userVisionboards[0].name }}</h3>
                            
                            <!-- Cuando no hay imágenes, mostrar el collage de cuadros punteados -->
                            <div class="vb-collage-container" *ngIf="userVisionboards[0] && !userVisionboards[0].images.length">
                              <div class="vb-collage-placeholder">
                                <div class="vb-placeholder-box vb-placeholder-box--large"></div>
                                <div class="vb-placeholder-row">
                                  <div class="vb-placeholder-box vb-placeholder-box--medium"></div>
                                  <div class="vb-placeholder-box vb-placeholder-box--small"></div>
                                </div>
                                <div class="vb-placeholder-row">
                                  <div class="vb-placeholder-box vb-placeholder-box--small"></div>
                                  <div class="vb-placeholder-box vb-placeholder-box--medium"></div>
                                </div>
                              </div>
                              <p class="vb-placeholder-text">Añade imágenes para crear tu collage</p>
                            </div>

                            <!-- Cuando hay imágenes, mostrar el collage con las imágenes -->
                            <div class="vb-collage-container" *ngIf="userVisionboards[0] && userVisionboards[0].images.length">
                              <div class="vb-collage-grid">
                                <div class="vb-collage-item" 
                                     *ngFor="let image of userVisionboards[0].images; let i = index"
                                     [ngClass]="getCollageItemClass(i, userVisionboards[0].images.length)">
                                  <img *ngIf="getPreviewForListItem(image?.imageId || '')" 
                                       [src]="getPreviewForListItem(image?.imageId || '')" 
                                       alt="Imagen {{ i + 1 }}" 
                                       class="vb-image-preview"
                                       title="Imagen {{ i + 1 }}">
                                  <div *ngIf="!getPreviewForListItem(image?.imageId || '')" class="vb-image-loading">
                                    <span>Cargando...</span>
                                  </div>
                                </div>
                                

                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="content-container" *ngIf="activeTab === 'financiera'">
        <div class="herramienta-placeholder">
            <h2>Herramienta Financiera</h2>
            <p>Esta función estará disponible próximamente.</p>
        </div>
    </div>

    <div class="content-container" *ngIf="activeTab === 'ikigai'">
        <app-ikigai></app-ikigai>
    </div>
</div>

<!-- Tutorial de Visionboard (solo se muestra cuando estamos editando si el usuario no lo ha completado antes) -->
<app-visionboard-tutorial 
    *ngIf="showVisionboardTutorial && activeTab === 'visionboard' && currentEditorVisionboardId !== null"
    (closeEvent)="closeTutorial()"
    (finishTutorialEvent)="finishTutorial()">
</app-visionboard-tutorial>